<template>
  <el-container>
    <el-main class="main">
      <span>{{ruleForm.id?'修改':'添加'}}图文</span>
      <el-button type="warning" size="mini" style="float: right" @click="returnBack">返回</el-button>
      <el-divider></el-divider>
      <el-form class="form" :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item label="图文标题" label-width="100px" prop="name">
          <el-input class="input" placeholder="请输入图文标题" v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="所属导航" label-width="100px" prop="navName">
          <el-select placeholder="请选择导航分类" v-model="ruleForm.navName">
            <el-option
              v-for="item in navList"
              :key="item.name"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="封面图" label-width="100px" prop="imgUrl">
          <el-upload
            class="avatar-uploader-2"
            :action="serverUrl"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
            <img v-if="ruleForm.imgUrl" :src="ruleForm.imgUrl" class="avatar" alt="">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="作者" label-width="100px">
          <el-input class="input" placeholder="请输入作者" v-model="ruleForm.author"></el-input>
        </el-form-item>
        <el-form-item label="正文" label-width="100px" prop="content" style="line-height: 0">
          <!-- 图片上传组件辅助-->
          <el-upload class="avatar-uploader-editor" :action="serverUrl" name="file" :headers="header" :show-file-list="false"
                     :on-success="uploadSuccess" :on-error="uploadError" :before-upload="beforeUpload"> </el-upload>
          <quill-editor v-model="ruleForm.content" ref="myQuillEditor" style="height: 500px" :options="editorOption">
            <!-- 自定义toolbar -->
            <div id="toolbar" slot="toolbar">
              <!-- Add a bold button -->
              <button class="ql-bold" title="加粗">Bold</button>
              <button class="ql-italic" title="斜体">Italic</button>
              <button class="ql-underline" title="下划线">underline</button>
              <button class="ql-strike" title="删除线">strike</button>
              <button class="ql-blockquote" title="引用"></button>
              <button class="ql-code-block" title="代码"></button>
              <button class="ql-header" value="1" title="标题1"></button>
              <button class="ql-header" value="2" title="标题2"></button>
              <!--Add list -->
              <button class="ql-list" value="ordered" title="有序列表"></button>
              <button class="ql-list" value="bullet" title="无序列表"></button>
              <!-- Add font size dropdown -->
              <select class="ql-header" title="段落格式">
                <option selected>段落</option>
                <option value="1">标题1</option>
                <option value="2">标题2</option>
                <option value="3">标题3</option>
                <option value="4">标题4</option>
                <option value="5">标题5</option>
                <option value="6">标题6</option>
              </select>
              <select class="ql-size" title="字体大小">
                <option value="10px">10px</option>
                <option value="12px">12px</option>
                <option value="14px">14px</option>
                <option value="16px" selected>16px</option>
                <option value="18px">18px</option>
                <option value="20px">20px</option>
                <option value="30px">30px</option>
              </select>
              <select class="ql-font" title="字体">
                <option value="SimSun">宋体</option>
                <option value="SimHei">黑体</option>
                <option value="Microsoft-YaHei">微软雅黑</option>
                <option value="KaiTi">楷体</option>
                <option value="FangSong">仿宋</option>
                <option value="Arial">Arial</option>
              </select>
              <!-- Add subscript and superscript buttons -->
              <select class="ql-color" value="color" title="字体颜色"></select>
              <select class="ql-background" value="background" title="背景颜色"></select>
              <select class="ql-align" value="align" title="对齐"></select>
              <button class="ql-clean" title="清除字体样式"></button>
              <button class="ql-image" title="照片"></button>
            </div>
          </quill-editor>

        </el-form-item>
        <el-form-item label="排序" label-width="100px" prop="priority" style="margin-top: 80px">
          <el-input class="input" placeholder="请输入排序" v-model="ruleForm.priority"></el-input>
        </el-form-item>
        <el-form-item style="text-align: center">
          <el-button type="primary" @click="submitForm('ruleForm')" :loading="loading">保存</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
// 工具栏配置
import {queryArticlePageList, saveArticle, updateArticle} from "../../../../api/system/articleSettings";
import {Quill,quillEditor} from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import '@/assets/styles/font.css'
import {mapGetters} from "vuex";
import {getCompanyByAdmin} from "../../../../api/system/org-storage";

// 自定义字体大小
let Size = Quill.import('attributors/style/size')
Size.whitelist = ['10px', '12px', '14px', '16px', '18px', '20px', '30px']
Quill.register(Size, true)

// 自定义字体类型
let fonts = ['SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial', 'Times-New-Roman', 'sans-serif',
  '宋体', '黑体'
]
let Font = Quill.import('formats/font')
Font.whitelist = fonts
Quill.register(Font, true)

export default {
  name: "index",
  components: {
    quillEditor
  },
  data() {
    return {
      navList:[],
      ruleForm:{
        id:'',
        navName:'',
        name:'',
        imgUrl:'',
        status:'1',
        author:'',
        content:'',
        priority:''
      },
      companyId:'',
      loading:false,
      rules: {
        name: [
          { required: true, message: '请输入图文标题', trigger: 'blur' },
        ],
        navName: [
          { required: true, message: '请选择所属导航', trigger: 'blur' }
        ],
        imgUrl: [
          { required: true, message: '请上传封面图', trigger: 'blur' }
        ],
        priority: [
          { required: true, message: '请输入排序', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入正文', trigger: 'blur' }
        ]
      },
      quillUpdateImg:false,
      serverUrl: 'https://wellhope.godaji.com/api/osp/articleSettings/image/upload',  // 这里写你要上传的图片服务器地址
      header: {token: sessionStorage.token},  // 有的图片服务器要求请求头需要有token
      editorOption: {
        placeholder: "请输入...", //文章初始化提示语
        theme: "snow", // or 'bubble'
        modules: {
          toolbar: {
            container: '#toolbar',
            handlers: {
              'image': function (value) {
                if (value) {
                  // 触发input框选择图片文件
                  document.querySelector('.avatar-uploader-editor input').click()
                } else {
                  this.quill.format('image', false);
                }
              },
            }
          }
        }
      },
    };
  },
  computed: {
    ...mapGetters(["currentUser"])
  },
  mounted() {
    this.getCompanyByAdmin()
    if(this.$route.params.teletextList != null){
      this.ruleForm = JSON.parse(this.$route.params.teletextList)
    }
    //addQuillTitle()
    // this.getNavList()
  },
  methods:{
    getCompanyByAdmin(){
      let param = {'id':this.currentUser.id}
      getCompanyByAdmin(param).then(res => {
        if(res.data.length > 0){
          this.companyId = res.data[0].id
        }
        this.getNavList()
      }).catch(err=>{
        console.log(err)
      })
    },
    getNavList(){
      let param = {}
      param.type = 1
      param.companyId = this.companyId
      queryArticlePageList(param).then(res => {
        // console.log(res.data);
        this.navList = res.data.records
      }).catch(err=>{
        console.log(err)
      })
    },
    handleAvatarSuccess(res, file) {
      this.ruleForm.imgUrl = res.data
      // console.log(this.ruleForm.imgUrl)
      // this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpg" || file.type === "image/png" || file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传图标只能是 JPG或PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },

    // 富文本图片上传成功
    uploadSuccess(res,file) {
      console.log(res)
      let quill = this.$refs.myQuillEditor.quill
      // 如果上传成功
      if (res.code === 200 && res.data !== null) {
        // 获取光标所在位置
        let length = quill.getSelection().index;
        // 插入图片res.url为服务器返回的图片地址
        quill.insertEmbed(length, 'image', res.data)
        // 调整光标到最后
        quill.setSelection(length + 1)
      } else {
        this.$message.error('图片插入失败')
      }
    },
    // 富文本图片上传失败
    uploadError() {
      this.$message.error('图片插入失败')
    },
    beforeUpload(file) {
      const isJPG = file.type === "image/jpg" || file.type === "image/png" || file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传图标只能是 JPG或PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    submitForm(formName) {
      this.loading = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = {}
          param.name = this.ruleForm.name
          param.imgUrl = this.ruleForm.imgUrl
          param.status = this.ruleForm.status
          param.content = this.ruleForm.content
          param.author = this.ruleForm.author
          param.priority = this.ruleForm.priority
          param.navName = this.ruleForm.navName
          param.type = 2
          param.companyId = this.companyId
          if(this.ruleForm.id === ''){
            saveArticle(param).then(res => {
              if(res.code === 200){
                this.$message.success('保存成功');
                this.returnBack()
                this.loading = false
              }
            }).catch(()=>{
              this.loading = false
              this.$message.error('添加失败，请重试');
            })
          }else{
            param.id = this.ruleForm.id
            updateArticle(param).then(res => {
              if(res.code === 200){
                this.$message.success('保存成功');
                this.returnBack()
                this.loading = false
              }
            }).catch(()=>{
              this.loading = false
              this.$message.error('添加失败，请重试');
            })
          }
        }else{
          this.loading = false
          this.$message.error('添加失败，请重试');
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    returnBack(){
      this.$router.push({path: "/settings/teletext/list"});
    },
  }
}
</script>

<style scoped>
  .avatar-uploader >>> .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader >>> .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-2 >>> .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader-2 >>> .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
  }
  .avatar {
    width: 120px;
    height: 120px;
    display: block;
  }
  .input{
    width: 480px;
  }
  .main{
    height: 95vh;
  }
  ::v-deep .el-form-item__content{
    line-height: 14px;
  }
</style>
